import * as React from "react";
import { Component } from "react";
import { loginProps, loginState } from "./interface";
import Button from "../../widgets/button";
import { FieldItem, FIELD_TYPES } from "../../widgets/fields";
import { Link, Redirect } from "react-router-dom";
import { showToaster, toasterTypes } from "../../widgets";
import { authenticationService } from "../../service";
import { loginResponse } from "../../model";
import { UserHelper, Validation } from "../../utils";
import { userRoles } from "../../constants";
class Login extends Component<loginProps, loginState> {
  constructor(props: loginProps) {
    super(props);
    this.state = {
      userName: "",
      password: "",
      isAuthenticated: false,
    };
  }

  componentDidMount() {
    // clear localstorage if user not logged
    if (Validation.isUserLogged()) {
      this.setState({ isAuthenticated: true });
    } else {
      localStorage.clear();
    }
  }

  handleOnChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    const state: any = { ...this.state };
    state[name] = value;
    this.setState(state);
  };

  onSubmit = () => {
    // TODO Validation

    authenticationService
      .loginRequest(this.state.userName, this.state.password)
      .subscribe({
        next: (data: loginResponse) => {
          try {
            if (data.status && data.statusCode === 200) {
              console.log("User Data", data.userdata);
              localStorage.setItem("user", JSON.stringify(data.userdata));
              localStorage.setItem(
                "token",
                JSON.stringify(data["x-auth-token"])
              );
              localStorage.setItem("id", JSON.stringify(data["x-userid"]));
              // auth success
              this.setState({ isAuthenticated: true });
            } else {
              showToaster(toasterTypes.ERROR, data.message);
            }
          } catch (error) {
            console.error(error.message);
          }
        },
        error: (error: any) => {
          console.log(error);
          showToaster(toasterTypes.ERROR, error.message);
          window.location.reload();
        },
        completed: () => {},
      });
  };

  render() {
    const {
      handleOnChange,
      onSubmit,
      state: { userName, password, isAuthenticated },
    } = this;
    if (isAuthenticated) {
      const role: any = UserHelper.getUserDetails()?.user_role_id;
      switch (role) {
        case userRoles.VOLUNTEER:
          return <Redirect to="/volunteerDashboard" />;

        case userRoles.EXTERNAL:
          return <Redirect to="/" />;

        case userRoles.STATE_ADMIN:
        case userRoles.SUPER_ADMIN:
        case userRoles.DISTRICT_ADMIN:
          return <Redirect to="/projectListDashboard" />;

        default:
          return <Redirect to="/" />;
      }
    }

    return (
      <div>
        <section id="Login">
          <div className="Container">
            <div className="Login_card">
              <div className="card">
                <div className="text-center Company_Logo mb-3">
                  <Link to="/">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/Vruksha_logo.png`}
                      alt="logo"
                    />
                  </Link>
                </div>

                <div className="email-login">
                  <form>
                    <FieldItem
                      onChange={handleOnChange}
                      value={userName}
                      name="userName"
                      placeholder="Email ID"
                      type={FIELD_TYPES.TEXT}
                      className="form-control"
                    />
                    <FieldItem
                      onChange={handleOnChange}
                      value={password}
                      name="password"
                      placeholder="Password"
                      type={FIELD_TYPES.TEXT_EYE}
                      className="form-control mt-4"
                      iconClassName="loginPasswordEye"
                    />
                  </form>
                </div>

                <span>
                  <Button
                    type="button"
                    onClick={onSubmit}
                    className="btn cta-btn"
                    label="Log In"
                    id="login"
                  />
                </span>
                <ul className="Remmber_Forgot_box">
                  <li>
                    <div className="form-check">
                      <input
                        className="form-check-input "
                        type="checkbox"
                        value=""
                        id="defaultCheck1"
                      />
                      <label className="form-check-label">Remember Me</label>
                    </div>
                  </li>
                  <li className="forget-pass">
                    <Link to="/forgetpassword"> Forgot Password?</Link>
                  </li>
                </ul>

                <div className="Not_registed_box">
                  <p className="subtitle">
                    Not Registered? <Link to="/signup"> Sign-up now</Link>
                  </p>
                </div>

                <div className="social-login">
                  <button className="google-btn">
                    <img
                      alt="Google"
                      src="data:image/svg+xml;base64,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"
                    />
                    <p className="btn-text"> Google</p>
                  </button>
                  <button className="fb-btn">
                    <img
                      alt="FB"
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDI5MS4zMTkgMjkxLjMxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjkxLjMxOSAyOTEuMzE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBzdHlsZT0iZmlsbDojM0I1OTk4OyIgZD0iTTE0NS42NTksMGM4MC40NSwwLDE0NS42Niw2NS4yMTksMTQ1LjY2LDE0NS42NmMwLDgwLjQ1LTY1LjIxLDE0NS42NTktMTQ1LjY2LDE0NS42NTkNCgkJUzAsMjI2LjEwOSwwLDE0NS42NkMwLDY1LjIxOSw2NS4yMSwwLDE0NS42NTksMHoiLz4NCgk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTE2My4zOTQsMTAwLjI3N2gxOC43NzJ2LTI3LjczaC0yMi4wNjd2MC4xYy0yNi43MzgsMC45NDctMzIuMjE4LDE1Ljk3Ny0zMi43MDEsMzEuNzYzaC0wLjA1NQ0KCQl2MTMuODQ3aC0xOC4yMDd2MjcuMTU2aDE4LjIwN3Y3Mi43OTNoMjcuNDM5di03Mi43OTNoMjIuNDc3bDQuMzQyLTI3LjE1NmgtMjYuODF2LTguMzY2DQoJCUMxNTQuNzkxLDEwNC41NTYsMTU4LjM0MSwxMDAuMjc3LDE2My4zOTQsMTAwLjI3N3oiLz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K"
                    />
                    <p className="btn-text"> Facebook</p>
                  </button>
                </div>
              </div>
            </div>

            <div className="Copyright_box">Copyright &copy; 2021, Mission Green Earth</div>
          </div>
        </section>
      </div>
    );
  }
}

export default Login;
